export const convertToReadableDecimal = (number: number): number => {
  if (!number) {
    return 0;
  }
  return Math.round(number / 10000) / 100;
};
